export default "__VITE_ASSET__BDlFHWKU__"